import React, { useEffect, useState } from "react";
import PublicMogul from "./PublicMogul";
import Landing from "./Landing";
import api from "../lib/api";

const APP_HOSTS = new Set([
  "growth-sync-pro.preview.emergentagent.com",
  "zerotothousands.com",
  "localhost",
  "127.0.0.1",
]);

/**
 * Root dispatcher — if accessed via a Mogul's custom domain, render their public page.
 * Otherwise render the marketing Landing.
 */
export default function HostAwareRoot() {
  const [resolved, setResolved] = useState(null); // null=loading, {kind:'landing'}, {kind:'mogul', profile}

  useEffect(() => {
    const host = window.location.hostname.toLowerCase();
    if (APP_HOSTS.has(host)) {
      setResolved({ kind: "landing" });
      return;
    }
    // Try to resolve as a custom Mogul domain
    api.mogulByDomain(host)
      .then((profile) => setResolved({ kind: "mogul", profile }))
      .catch(() => setResolved({ kind: "landing" }));
  }, []);

  if (!resolved) return <div className="min-h-screen flex items-center justify-center text-xs mono uppercase text-[#A1A1AA]">resolving…</div>;
  if (resolved.kind === "mogul") {
    // PublicMogul fetches by slug; we already have the profile so we pass it via context
    return <PublicMogul prefetched={resolved.profile}/>;
  }
  return <Landing/>;
}
